import { useEffect } from 'react';
// redux
import { useDispatch, useSelector } from '../store';
import {
  fetchRelationshipManager,
  getRelationshipManagerState,
} from '../store/partners/relationshipManager.slice';

// ----------------------------------------------------------------------

const readCurrentPartner = () => {
  try {
    return JSON.parse(localStorage.getItem('currentPartner') || 'null');
  } catch {
    return null;
  }
};

/**
 * Relationship manager of the partner the panel is currently showing.
 * Only partners with a parent can have one, so a root partner never fetches.
 * `currentPartner` only changes with a full reload (login / Manage Account),
 * so reading it from localStorage on render is enough here.
 */
export default function useRelationshipManager() {
  const dispatch = useDispatch();
  const { partnerId, manager, isLoading } = useSelector(getRelationshipManagerState);

  const currentPartner = readCurrentPartner();
  const currentPartnerId = currentPartner?._id || null;
  const hasParent = Boolean(currentPartner?.parent);

  useEffect(() => {
    if (!currentPartnerId || !hasParent) return;
    if (partnerId === currentPartnerId) return;
    dispatch(fetchRelationshipManager(currentPartnerId));
  }, [dispatch, currentPartnerId, hasParent, partnerId]);

  if (!hasParent) {
    return { manager: null, isLoading: false };
  }

  const isCurrent = partnerId === currentPartnerId;

  return {
    manager: isCurrent ? manager : null,
    isLoading: !isCurrent || isLoading,
  };
}
